// composables/usePriceFilter.ts ------------------------------------------------
import { reactive } from '@nuxtjs/composition-api';

export interface PriceRange {
  min: number;
  max: number;
}

export function usePriceFilter(initial: PriceRange): {
  state: { touched: boolean; selected: { min: number; max: number; }; absolute: { min: number; max: number; }; };
  setAbsolute: (min: number, max: number) => void;
  setSelected: (min: number, max: number) => void;
  serialize: () => string[];
  hydrate: (filters: string[]) => void;
} {
  const state = reactive({
    // “true” after the customer touches slider / check-boxes
    touched: false,
    // currently selected range (UI + search use this)
    selected: { ...initial },
    // full range coming from Algolia facets_stats
    absolute: { ...initial }
  });

  function setAbsolute(min: number, max: number) {
    state.absolute = { min, max };
    if (!state.touched) state.selected = { min, max };
  }

  function setSelected(min: number, max: number) {
    state.touched = true;
    state.selected = { min, max };
  }

  function serialize(): string[] {
    return state.touched
      ? [
        // `priceAfterDiscount>=${state.selected.min}`,
        `priceAfterDiscount>=${state.selected.min}`,
        // `priceAfterDiscount<=${state.selected.max}`
        `priceAfterDiscount<=${state.selected.max}`
      ]
      : [];
  }

  function hydrate(filters: string[]) {
    // const gte = filters.find(f => f.startsWith('priceAfterDiscount>='));
    const gte = filters.find(f => f.startsWith('priceAfterDiscount>='));
    // const lte = filters.find(f => f.startsWith('priceAfterDiscount<='));
    const lte = filters.find(f => f.startsWith('priceAfterDiscount<='));
    if (!gte && !lte) return;

    state.touched = true;
    state.selected = {
      min: gte ? Number(gte.split('>=')[1]) : state.absolute.min,
      max: lte ? Number(lte.split('<=')[1]) : state.absolute.max
    };
  }

  return { state, setAbsolute, setSelected, serialize, hydrate };
}
